<template>
  <v-dialog v-model="messageBox.dialog" max-width="550" @keydown.esc="cancel" persistent>
    <v-card>
      <v-toolbar dark flat :color="appBarColor" dense>
        <v-toolbar-title>{{ messageBox.title }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text
        class="pt-5"
        v-show="!!messageBox.message"
        v-dompurify-html="messages"
      ></v-card-text>
    <v-divider></v-divider>
      <v-card-actions class="pt-2">
        <v-spacer></v-spacer>
        <template  v-if="messageBox.boxType==='alert'">
          <rx-btn @click.native="cancel" :color="messageBox.messageType" outlined tile class="ma-1">
            <!-- <v-icon left>$vuetify.icons.btn_cancel</v-icon> -->
            {{ $t("common.btn.close")}}
          </rx-btn>
        </template>
        <template v-else>
          <rx-btn @click.native="cancel" min-width="100" color="grey" outlined tile class="ma-1">
            <!-- <v-icon left>$vuetify.icons.btn_cancel</v-icon> -->
            {{ $t("common.btn.no")}}
          </rx-btn>
          <rx-btn @click.native="agree" min-width="100" :color="messageBox.messageType" outlined tile class="ml-1">
            <!-- <v-icon left>$vuetify.icons.btn_save</v-icon> -->
            {{ $t("common.btn.yes")}}
          </rx-btn>
        </template>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("app");
export default {
  computed: {
    ...mapState(["messageBox"]),
    messages() {
      return this.messageBox.message? this.messageBox.message.replace(/(?:\r\n|\r|\n)/g, '<br />'):"";
    },
    appBarColor() {
        switch (this.messageBox.messageType) {
          case "warning":
            return `${this.messageBox.messageType} darken-0`;
          case "error":
            return `${this.messageBox.messageType} lighten-1`;      
          default:
            return  `${this.messageBox.messageType} lighten-1`;
        }
    }

  },
  methods: {
    agree() {
      this.$store.dispatch("app/closeMessageBox", true)
    },
    cancel() {
      this.$store.dispatch("app/closeMessageBox", false)
    },
  },
};
</script>